const STORAGE_ITEM_NAME = 'B2BAllDocumentsAccessRequestSent';

export const getAllDocumentsAccessRequestTimer = () => {
    return localStorage.getItem(STORAGE_ITEM_NAME);
};

export const setAllDocumentsAccessRequestTimer = (value: string) => {
    localStorage.setItem(STORAGE_ITEM_NAME, value);
};
